import { subscribe } from 'pub-sub';

subscribe('notify:event', (topic, message) => {
	window.hcstatic.sitews.send_event(message);
});
